import Navbar from './nav/navbar';
import Footer from './footer/footer';

function Template() {
  return (
    <div>
	<Navbar></Navbar>
	<Footer></Footer>
    </div>
  );
}

export default Template;
